import React from 'react';
import { AzureMLKey, DurableApp } from '../../../../core/modules/pipelines/pipelines.model';
import AzureMLDetail from './AzureMLDetail';
import DurableDetail from './DurableDetail';
import FunctionDetail from './FunctionDetail';
import TimerDetail from './TimerDetail';

export interface IDetailViewProps {
  pipelineId: string;
  scheduleHuman: string;
  displayName: string;
  description?: string | null;
  onClose?: () => void;
}

type Renderer = (props: IDetailViewProps) => React.ReactElement;

/** Pipeline-type prefix → detail-view renderer map. */
const REGISTRY: Array<{ prefix: string; render: Renderer }> = [
  {
    prefix: 'azureml.',
    render: ({ pipelineId, displayName, scheduleHuman, description, onClose }) => {
      const key = pipelineId.split('.')[1] as AzureMLKey;

      return (
        <AzureMLDetail
          pipelineKey={key}
          title={displayName}
          schedule={scheduleHuman}
          description={description}
          onClose={onClose}
        />
      );
    }
  },
  {
    prefix: 'durable.',
    render: ({ pipelineId, displayName, scheduleHuman, description, onClose }) => {
      // durable.<app>.<orchestrator_with_underscores> → kebab-case orchestrator.
      const [, app, ...rest] = pipelineId.split('.');
      const orchestrator = rest.join('.').replace(/_/g, '-');

      return (
        <DurableDetail
          app={app as DurableApp}
          orchestrator={orchestrator}
          title={displayName}
          schedule={scheduleHuman}
          description={description}
          onClose={onClose}
        />
      );
    }
  },
  {
    prefix: 'function.',
    render: ({ pipelineId, displayName, scheduleHuman, description, onClose }) => (
      <FunctionDetail
        pipelineId={pipelineId}
        title={displayName}
        schedule={scheduleHuman}
        description={description}
        onClose={onClose}
      />
    )
  },
  {
    prefix: 'timer.',
    render: ({ pipelineId }) => <TimerDetail pipelineId={pipelineId} />
  }
];

export const renderDetailView = (props: IDetailViewProps): React.ReactElement | null => {
  const match = REGISTRY.find((entry) => props.pipelineId.startsWith(entry.prefix));

  if (!match) {
    return null;
  }

  return match.render(props);
};
